import { saveAs } from 'file-saver'
import * as NGL from 'ngl'
import { getRepr, hasRepr, removeRepr } from './NglUtils.js'
// import { Color, Vector3, Matrix4 } from 'three'
import { Color } from 'three'
import { bfactorColor } from './NglColor.js'

function NglObject (store, name, type, components, selections, params) {
  this.store = store

  this.id = Math.floor(Math.random() * 10000000) + 1

  this.type = type

  this.name = name

  this.chains = []

  this.residues = []

  this.distanceRepresentations = []

  this.compList = components

  this.seleList = selections

  this.visible = (type !== 'selection')

  this.labels = {}

  if (type === 'structure-component') {
    components[0].structure.eachChain(chain => {
      this.chains.push(chain.clone())
      let ls = []
      chain.eachResidue(residue => {
        let r = residue.clone()
        r.active = false
        ls.push(r)
      })
      this.residues.push(ls)
    })
  } else if (type === 'distance') {
    this.distanceRepresentations = []
    components.forEach((comp, i) => {
      this.distanceRepresentations.push(comp.addRepresentation('distance', params[i]))
    })
  }
}

NglObject.prototype = {
  get components () {
    if (this.type === 'all') {
      return this.store.stage.compList
    } else {
      return this.compList
    }
  },

  set components (components) {
    this.compList = components
  },

  get selections () {
    if (this.type === 'all') {
      return this.store.stage.compList.map(comp => 'all')
    } else {
      return this.seleList
    }
  },

  set selections (selections) {
    this.seleList = selections
  }
}

NglObject.prototype.setActivities = function (sele) {
  this.residues.forEach(rs => {
    rs.forEach(r => {
      r.active = sele.residueTest(r)
    })
  })
}

// NglObject.prototype.showButton = function () {
//   this.visible = true
//   let ls = document.querySelectorAll(`#object-row-${this.id} .object-name`)
//   ls.forEach(e => {
//     e.style.borderLeft = '5px solid grey'
//   })
// }

// NglObject.prototype.hideButton = function () {
//   this.visible = false
//   let ls = document.querySelectorAll(`#object-row-${this.id} .object-name`)
//   ls.forEach(e => {
//     e.style.borderLeft = '5px solid white'
//   })
// }

NglObject.prototype.updateSelection = function () {
  if (this.type === 'selection') {
    if (this.visible) {
      this.components.forEach((comp, i) => {
        let obj = this.store.getObjectByComponent(comp)
        if (obj) {
          obj.residues.forEach(rs => {
            rs.forEach(r => {
              let active = this.selections[i].residueTest(r)
              if (active !== r.active) {
                r.active = active
              }
            })
          })
        }
      })

      this.components.forEach((comp, i) => {
        removeRepr(comp, 'hyperball')
        comp.addRepresentation('hyperball', {
          sele: this.selections[i].string,
          color: '#FA61E0'
        })
      })
    } else {
      this.components.forEach((comp, i) => {
        let obj = this.store.getObjectByComponent(comp)
        if (obj) {
          obj.residues.forEach(rs => {
            rs.forEach(r => {
              let active = this.selections[i].residueTest(r)
              if (active) {
                r.active = false
              }
            })
          })
        }
      })

      this.components.forEach((comp, i) => {
        removeRepr(comp, 'hyperball')
      })
    }
  }
}

NglObject.prototype.toggle = function () {
  if (this.visible) {
    this.hide()
  } else {
    this.show()
  }
}

NglObject.prototype.hide = function () {
  this.visible = false

  if (this.type === 'all') {
    this.store.structureObjects.forEach(obj => {
      obj.visible = false
      obj.components[0].setVisibility(false)
    })
    this.store.distanceObjects.forEach(obj => {
      obj.visible = false
      obj.distanceRepresentations.forEach(repr => {
        repr.setVisibility(false)
      })
    })
  } else if (this.type === 'distance') {
    this.distanceRepresentations.forEach(repr => {
      repr.setVisibility(false)
    })
  } else if (this.type === 'structure-component') {
    this.components[0].setVisibility(false)
  } else if (this.type === 'selection') {
    this.updateSelection()
  }
}

NglObject.prototype.show = function () {
  if (this.type === 'all') {
    this.visible = true
    this.store.structureObjects.forEach(obj => {
      obj.visible = true
      obj.components[0].setVisibility(true)
    })
    this.store.distanceObjects.forEach(obj => {
      obj.visible = true
      obj.distanceRepresentations.forEach(repr => {
        repr.setVisibility(true)
      })
    })
  } else if (this.type === 'distance') {
    this.visible = true
    this.distanceRepresentations.forEach(repr => {
      repr.setVisibility(true)
    })
  } else if (this.type === 'structure-component') {
    this.visible = true
    this.components[0].setVisibility(true)
  } else if (this.type === 'selection') {
    this.store.selectionObjects.forEach(obj => {
      if (obj.visible) {
        obj.visible = false
        obj.updateSelection()
      }
    })

    this.visible = true
    this.updateSelection()
  }
}

NglObject.prototype.zoom = function () {
  if (this.type === 'all') {
    this.store.stage.autoView()
  } else {
    this.components[0].autoView()
  }
}

NglObject.prototype.clearLabel = function (t) {
  if (this.type === 'all') {
    this.store.structureObjects.forEach(obj => obj.clearLabel())
  } else {
    this.components.forEach((comp, i) => {
      let obj = this.store.getObjectByComponent(comp)
      for (let type in obj.labels) {
        console.log(`clear labels: ${type}`)
        let repr = obj.labels[type]
        repr.setSelection(`(${repr.repr.selection.string}) and (not (${this.selections[i].string}))`)
      }
    })
  }
}

NglObject.prototype.showLabel = function (t) {
  if (t === 'clear') {
    this.clearLabel()
  } else {
    if (this.type === 'all') {
      this.store.structureObjects.forEach(obj => obj.showLabel(t))
    } else {
      this.components.forEach((comp, i) => {
        let obj = this.store.getObjectByComponent(comp)
        if (!(t in obj.labels)) {
          console.log(`(${this.selections[i].string}) and (${this.store.labelSettings[t].sele})`)
          obj.labels[t] = comp.addRepresentation('label', {
            sele: `(${this.selections[i].string}) and (${this.store.labelSettings[t].sele})`,
            labelType: 'format',
            labelFormat: this.store.labelSettings[t].format,
            radiusScale: 0.8,
            fixedSize: true,
            fontWeight: 'bold'
          })
        } else {
          let repr = obj.labels[t]
          repr.setSelection(`(${repr.repr.selection.string}) or ((${this.selections[i].string}) and (${this.store.labelSettings[t].sele}))`)
            //                  let visible = repr.getVisibility()
            //                  if (visible) {
            //                    repr.setSelection(`(${repr.repr.selection.string}) or ((${this.selections[i].string}) and (${this.store.labelSettings[t].sele}))`)
            //                  } else {
            //                    repr.setParameters({
            //                      sele: `(${this.selections[i].string}) and (${this.store.labelSettings[t].sele})`,
            //                      visible: true
            //                    })
            //                  }
        }
      })
    }
  }
}

NglObject.prototype.showRepresentation = function (t, showAs = false) {
  if (showAs) {
    this.hideRepresentation('everything')
  }

  let types = (t === 'everything' ? this.store.representationTypes : [t])
  types.forEach(type => {
    if (this.type === 'all' || this.type === 'structure-component') {
      this.components.forEach(comp => {
        if (!hasRepr(comp, type)) {
          comp.addRepresentation(type)
        }
        let repr = getRepr(comp, type)
        repr.setSelection('all')
        repr.setVisibility(true)
      })
    } else if (this.type === 'selection') {
      this.components.forEach((comp, i) => {
        if (!hasRepr(comp, type)) {
          comp.addRepresentation(type, {
            sele: this.selections[i].string
          })
        } else {
          let repr = getRepr(comp, type)
          let visible = repr.getVisibility()
          if (visible) {
            repr.setSelection(`(${repr.repr.selection.string}) or (${this.selections[i].string})`)
          } else {
            repr.setParameters({
              sele: this.selections[i].string,
              visible: true
            })
          }
        }
      })
    }
  })
}

NglObject.prototype.hideRepresentation = function (t) {
  let types = (t === 'everything' ? this.store.representationTypes : [t])
  types.forEach(type => {
    if (this.type === 'all' || this.type === 'structure-component') {
      this.components.forEach(comp => {
        if (hasRepr(comp, type)) {
          let repr = getRepr(comp, type)
          repr.setVisibility(false)
        }
      })
    } else if (this.type === 'selection') {
      this.components.forEach((comp, i) => {
        if (hasRepr(comp, type)) {
          let repr = getRepr(comp, type)
          let visible = repr.getVisibility()
          if (visible) {
            repr.setSelection(`(${repr.repr.selection.string}) and (not (${this.selections[i].string}))`)
          }
        }
      })
    }
  })
}

NglObject.prototype.setColor = function (scheme) {
  if (scheme === 'bfactor') {
    scheme = bfactorColor
  }

  this.store.representationTypes.forEach(type => {
    if (this.type === 'all' || this.type === 'structure-component') {
      this.components.forEach(comp => {
        if (hasRepr(comp, type)) {
          getRepr(comp, type).setColor(scheme)
        }
      })
    } else if (this.type === 'selection') {
      let o = this
      this.components.forEach((comp, i) => {
        if (hasRepr(comp, type)) {
          let repr = getRepr(comp, type)
          let sele = repr.repr.selection.string
          let par = repr.getParameters()

          var foo = function (params) {
            if (!foo.colormakerList) {
              foo.colormakerList = []

              if (NGL.ColormakerRegistry.hasScheme(scheme)) {
                foo.colormakerList.push(NGL.ColormakerRegistry.getScheme({scheme: scheme, structure: comp.structure}))
              } else {
                foo.colormakerList.push(NGL.ColormakerRegistry.getScheme({scheme: 'uniform', value: new Color(scheme).getHex(), structure: comp.structure}))
              }

              foo.colormakerList.push(NGL.ColormakerRegistry.getScheme({scheme: par.colorScheme, value: par.colorValue, scale: par.colorScale, structure: comp.structure}))

              foo.selectionList = [new NGL.Selection(o.selections[i].string), new NGL.Selection(`(${sele}) and (not (${o.selections[i].string}))`)]
            }

            this.atomColor = a => {
              for (let i = 0, n = foo.selectionList.length; i < n; ++i) {
                const test = foo.selectionList[i].test
                if (test && test(a)) {
                  return foo.colormakerList[i].atomColor(a)
                }
              }
              return 0xFFFFFF
            }
          }

          let schemeId = NGL.ColormakerRegistry.addScheme(foo)

          repr.setColor(schemeId)
        }
      })
    }
  })
}

NglObject.prototype.rename = function (name) {
  this.name = name
}

NglObject.prototype.export = function () {
  if (this.type === 'selection') {
    alert('To be implemented')
  } else if (this.type === 'structure-component') {
    let pdbWriter = new NGL.PdbWriter(this.compList[0].structure)
    let content = pdbWriter.getData()
    let blob = new Blob([content], { type: 'text/plain' })
    saveAs(blob, `${this.name}.pdb`)
  } else {
    alert('To be implemented')
  }
}

export default NglObject
